"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var axios_1 = require("Utils/axios");
var signature_pad_1 = __importDefault(require("signature_pad"));
var Signature = function () {
    var canvas = react_1.default.useRef();
    var signaturePad;
    if ((canvas === null || canvas === void 0 ? void 0 : canvas.current) !== undefined) {
        signaturePad = new signature_pad_1.default(canvas.current, {
            minWidth: 5,
            maxWidth: 10,
            penColor: "rgb(66, 133, 244)"
        });
        signaturePad.on();
    }
    var saveSignature = (function () {
        if (signaturePad.isEmpty()) {
            alert("Please provide a signature first.");
        }
        else {
            var dataURL = signaturePad.toDataURL('image/jpeg', 1.0);
            axios_1.signaturePut(dataURL);
        }
    });
    return (react_1.default.createElement("div", { id: "signature-pad", className: "signature-pad" },
        react_1.default.createElement("div", { className: "signature-pad--body" },
            react_1.default.createElement("canvas", { ref: canvas }),
            react_1.default.createElement("button", { onClick: saveSignature }))));
};
exports.default = Signature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvQ29tcG9uZW50cy9nYXRld2F5L1NpZ25hdHVyZS9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxnREFBeUI7QUFDekIscUNBQTBDO0FBQzFDLGdFQUF5QztBQUV6QyxJQUFNLFNBQVMsR0FBNEI7SUFDekMsSUFBTSxNQUFNLEdBQUcsZUFBSyxDQUFDLE1BQU0sRUFBRSxDQUFBO0lBQzdCLElBQUksWUFBMEIsQ0FBQztJQUMvQixJQUFJLENBQUEsTUFBTSxhQUFOLE1BQU0sdUJBQU4sTUFBTSxDQUFFLE9BQU8sTUFBSyxTQUFTLEVBQUU7UUFDakMsWUFBWSxHQUFHLElBQUksdUJBQVksQ0FBQyxNQUFPLENBQUMsT0FBNEIsRUFBRTtZQUNwRSxRQUFRLEVBQUUsQ0FBQztZQUNYLFFBQVEsRUFBRSxFQUFFO1lBQ1osUUFBUSxFQUFFLG1CQUFtQjtTQUM5QixDQUFDLENBQUM7UUFDSCxZQUFZLENBQUMsRUFBRSxFQUFFLENBQUM7S0FDbkI7SUFDRCxJQUFNLGFBQWEsR0FBRyxDQUFDO1FBQ3JCLElBQUksWUFBWSxDQUFDLE9BQU8sRUFBRSxFQUFFO1lBQzFCLEtBQUssQ0FBQyxtQ0FBbUMsQ0FBQyxDQUFDO1NBQzVDO2FBQU07WUFDTCxJQUFJLE9BQU8sR0FBRyxZQUFZLENBQUMsU0FBUyxDQUFDLFlBQVksRUFBRSxHQUFHLENBQUMsQ0FBQztZQUN4RCxvQkFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1NBQ3ZCO0lBQ0gsQ0FBQyxDQUFDLENBQUM7SUFFSCxPQUFPLENBQ0wsdUNBQUssRUFBRSxFQUFDLGVBQWUsRUFBQyxTQUFTLEVBQUMsZUFBZTtRQUMvQyx1Q0FBSyxTQUFTLEVBQUMscUJBQXFCO1lBQ2xDLDBDQUFRLEdBQUcsRUFBRSxNQUFNLEdBQVc7WUFDOUIsMENBQVEsT0FBTyxFQUFFLGFBQWEsR0FBVyxDQUNyQyxDQUNGLENBQ1AsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELGtCQUFlLFNBQVMsQ0FBQyJ9